module.exports = __webpack_public_path__ + "img/notes_icon.612ff61f.svg";